// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadPlaceholder_root__N2_Lt","inner":"UploadPlaceholder_inner__LXQhJ","spinnerContainer":"UploadPlaceholder_spinnerContainer__dXJLL"};